import { mockClient } from "./mockClient"
import type {
  SubscriptionSummary,
  SubscriptionRecord,
  SubscriptionCheckoutSession,
} from "../types"

export type SubscriptionUpgradePayload = {
  priceId?: string
  quantity?: number
}

export type SubscriptionCancelPayload = {
  atPeriodEnd: boolean
}

export type SubscriptionCheckoutPayload = {
  contactId: string
  amountCents: number
  cadence: string
  currency?: string
  email?: string
  description?: string
}

export type SubscriptionCheckoutResponse = {
  subscription: SubscriptionRecord
  checkout_session: SubscriptionCheckoutSession
}

export async function fetchSubscription(demo: boolean, token?: string | null): Promise<SubscriptionSummary> {
  return mockClient.getSubscription(demo, token) as Promise<SubscriptionSummary>
}

export async function upgradeSubscription(
  demo: boolean,
  payload: SubscriptionUpgradePayload,
  token?: string | null,
): Promise<SubscriptionSummary> {
  return mockClient.upgradeSubscription(demo, payload, token) as Promise<SubscriptionSummary>
}

export async function cancelSubscription(
  demo: boolean,
  payload: SubscriptionCancelPayload,
  token?: string | null,
): Promise<SubscriptionSummary> {
  return mockClient.cancelSubscription(demo, payload, token) as Promise<SubscriptionSummary>
}

export async function createSubscriptionCheckout(
  demo: boolean,
  payload: SubscriptionCheckoutPayload,
  token?: string | null,
): Promise<SubscriptionCheckoutResponse> {
  return mockClient.createSubscriptionCheckout(demo, payload, token) as Promise<SubscriptionCheckoutResponse>
}
